const classOrder = [
    '125',
    '110A',
    '115',
    '120A',
    '210',
    '220',
    '230',
    '250',
    '260',
    '280B',
    '290A',
    '200',
    '140A',
    '144',
    '145',
    '520',
    '530',
    '540',
    '130',
    '100',
    '150',
    '300',
    '360',
    '340A',
    '320',
    '170',
    '180',
    '165A',
    '400',
    '410',
];

function getClassOrderIndex(code: string, order: string[] = classOrder): number {
    const idx = (order || []).indexOf(String(code || '').trim());
    return idx >= 0 ? idx : Number.MAX_SAFE_INTEGER;
}

export {
    classOrder,
    getClassOrderIndex,
}